export default {
    success: 'check circle outline',
    info: 'exclamation circle',
    warning: 'exclamation triangle',
    danger: 'exclamation',
    error: 'times'
}
